import { render, staticRenderFns } from "./jiancha.vue?vue&type=template&id=5e10e69e&scoped=true&"
import script from "./jiancha.vue?vue&type=script&lang=ts&"
export * from "./jiancha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e10e69e",
  null
  
)

export default component.exports